window.VH = window.VH === undefined ? {} : window.VH;
VH.AjaxModal = {
    init : function init() {
        let modal = $('#ajaxModal');
        $('#wrapper').on('click', '.ajaxModal', function () {
            let t = $(this),
                url = t.attr('href');

            $('.modal-header h4', modal).html(t.data('ajax-modal-title'));

            if (url === '#') {
                console.log([modal]);
                modal.modal('show');
            } else {
                $.get(url, function (data) {
                    $('.modal-body', modal).html(data);
                    modal.modal('show');
                });
            }
            return false;
        });
    }
};